<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <div class="sayfahead m-0">
      <h1><small>Talep ve Teklifler</small></h1>
      <el-button type="success" size="small" class="YeniBtn"
                 @click="YeniBtn">
        Talep Ekle
      </el-button>
    </div>
    <el-table
      v-if="Liste"
      :data="Liste"
      class="golgetable">
      <el-table-column
        label="Başlık"
        prop="Baslik">
      </el-table-column>
      <el-table-column
        label="Durum"
        prop="DurumText">
      </el-table-column>
      <el-table-column
        align="right">
        <template slot-scope="scope">
          <el-button-group>
            <el-tooltip v-if="Yetki" class="item" effect="dark" content="Düzenle"
                        placement="top-start">
              <el-button
                size="mini"
                type="primary"
                icon="feather-edit-2"
                @click="DuzenleBtn(scope.row)">
              </el-button>
            </el-tooltip>
            <el-tooltip v-if="Yetki" class="item" effect="dark"
                        content="Sil"
                        placement="top-start">
              <el-button
                size="mini"
                type="danger"
                icon="el-icon-delete-solid"
                @click="SilOnay(scope.row.id)">
              </el-button>
            </el-tooltip>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <BinaTalepModal @BinaTalepModal="SayfaYukle"
                    :BinaTalepModal="BinaTalepModal"
                    v-if="BinaTalepModal"
                    :data="Data"></BinaTalepModal>
  </div>
</template>

<script>
  import Yukleniyor from "../../../../Doc/Yukleniyor";
  import BinaTalepModal from "./Toplanti/BinaTalepModal";

  export default {
    props: ['Bina_id'],
    components: {BinaTalepModal, Yukleniyor},
    data() {
      return {
        lo: true,
        Data: {
          ModalBaslik: 'Toplantı Planla',
          Bina_id: null,
          tTarihi: null,
          Konu: null
        },
        Liste: null,
        BinaTalepModal: false
      }

    },
    methods: {
      SilOnay(id) {
        this.$confirm(this.$t('eGenel.1'), this.$t('eGenel.7'), {
          confirmButtonText: this.$t('eGenel.2'),
          cancelButtonText: this.$t('eGenel.3'),
          type: 'warning'
        }).then(() => {
          this.Sil(id)
        }).catch(() => {
          this.$message.info(this.$t('eGenel.8'));
        });
      },
      Sil(id) {
        this.$store.dispatch("Delete", {path: 'yonetim/bina/talep/' + id})
          .then(response => {
            if (response.Durum == "OK") {
              this.$message.success(response.Mesaj);
              this.SayfaYukle();
            } else {
              this.$message.warning(response.Mesaj);
              this.hata = response.Hata;
            }
          })

      },
      DuzenleBtn(data) {
        data.ModalBaslik = 'Talep Düzenle'
        this.Data = data;
        this.BinaTalepModal = true
      },
      YeniBtn() {
        this.Data = {
          ModalBaslik: 'Talep Ekle',
          Bina_id: this.Bina_id,
          Konu: null
        }
        this.BinaTalepModal = true
      },
      SayfaYukle() {
        this.BinaTalepModal = false;
        this.lo = true;
        this.$store.dispatch("Get", {path: 'yonetim/bina/talep/' + this.Bina_id})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Liste = response.Liste;
              this.lo = false;

            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      },

    },
    created() {
      this.SayfaYukle();
      this.Yetki = this.$store.getters.Yetki.yonetim == '2' ? true : false;
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/Tab/BinaTeklif.vue